










































































































































import { Context, ContextFactory } from '@/models/order-history/status/context/context'
import { getEditedOrderMessage } from '@/models/order-history/supersede-status'
import { AddToCartButtonEligibilityChecker } from '@spa/components/organisms/mypage/order/model/add-to-cart-button'
import {
  createOrderStatusViewModel,
  OrderStatusViewModel,
} from '@spa/components/organisms/mypage/order/model/order-status-view'
import { DeliveryIndicatorStatus } from '@spa/components/organisms/mypage/order/model/order-status-view/delivery-indicator'
import {
  getPaymentProblemStateView,
  shouldShowPaymentProblemState
} from '@spa/components/organisms/mypage/order/model/payment-problem-state'
import {
  getReorderAcceptabilityState,
  ReorderAcceptabilityState,
  reorderIsAcceptable,
} from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state'
import ReorderNotification, { ReorderNotificationDep } from '@spa/components/organisms/mypage/order/reorder/ReorderNotification.vue'
import { AddToCartButtonDependency } from '@spa/components/pages/mypage/order/models/add-to-cart-button-dependency'
import {
  getAddress1,
  getAddress2,
  getDeliveryName,
  isAllCatalogProducts,
} from '@spa/store/modules/orderHistory/functions/order'
import { Order, Product } from '@spa/store/modules/orderHistory/types'
import dateFormat from 'date-fns/format'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'
import { PluginMixin } from '../../../../mixins/plugin'
import DeliveryIndicator from '../../../organisms/indicator/DeliveryIndicator.vue'
import DeliveryTrackingLink from './DeliveryTrackingLink.vue'
import OrderProduct from './OrderProduct.vue'

@Component({
  components: {
    OrderProduct,
    DeliveryIndicator,
    DeliveryTrackingLink,
    ReorderNotification,
  },
})
export default class OrderListItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop()
  order: Order

  @Prop({ required: true })
  readonly addToCartButtonDependency: AddToCartButtonDependency

  get orderStatusContext(): Context {
    return ContextFactory.fromStore(this.order).create()
  }

  get statusView(): OrderStatusViewModel {
    return createOrderStatusViewModel(this.orderStatusContext)
  }

  get statusLabel(): string {
    return this.statusView.label
  }
  get statusLabelView() {
    return this.statusView.labelView
  }

  get statusDescription(): string | undefined {
    return this.statusView.description.forListView
  }

  get indicatorStatus(): DeliveryIndicatorStatus | undefined {
    return this.statusView.deliveryIndicatorStatus
  }

  get reorderAcceptabilityState(): ReorderAcceptabilityState {
    return getReorderAcceptabilityState(this.orderStatusContext)
  }

  get reorderNotificationData(): ReorderNotificationDep | undefined {
    if (!reorderIsAcceptable(this.reorderAcceptabilityState)) {
      return undefined
    }

    return {
      title: this.reorderAcceptabilityState.view.title,
      descriptions: this.reorderAcceptabilityState.view.description,
      link: this.reorderAcceptabilityState.createReorderPath(this.order.id),
      buttonLabel: this.reorderAcceptabilityState.view.buttonLabel,
    }
  }

  get trackingId(): string | undefined {
    // TODO: Use property when shipmentOrder is strictly typed.
    return _.get(this.order.shipmentOrder, 'external_trackingid')
  }

  get trackingUrl(): string | undefined {
    return _.get(this.order.deliveryTracking, 'url')
  }

  get deliveryUserName(): string {
    return getDeliveryName(this.order)
  }

  get zipcode(): string {
    return this.order.delivery.contact.address.code
  }

  get address1(): string {
    return getAddress1(this.order)
  }

  get address2(): string {
    return getAddress2(this.order)
  }

  get tel(): string {
    return this.order.delivery.contact.tel
  }

  get totalPrice(): number {
    return this.order.chargeSheet.total
  }

  get showTrackingId(): boolean {
    const trackingIdExist = this.trackingId !== undefined

    // カタログ商品（DM便）は配送追跡番号を非公開にする取り決めがあるため、
    // 全ての商品がカタログ商品の場合のみ非表示にする.
    // （カタログ同梱で通常商品にカタログが追加された注文ではお届け番号を表示する）
    // @see https://github.com/Everforth/growthpalette-front/issues/2396
    // @see https://github.com/Everforth/growthpalette-front/issues/9062
    return trackingIdExist && !isAllCatalogProducts(this.order)
  }

  get orderProducts(): Product[] {
    return _.filter(this.order.products, product => !product.isChild)
  }

  get sortedProducts(): Product[] {
    return _.sortBy(this.orderProducts, product => product.isNovelty)
  }

  get orderDate(): string {
    return dateFormat(new Date(this.order.createdAt), 'YYYY/MM/DD')
  }

  get orderDateTime(): string {
    return dateFormat(new Date(this.order.createdAt), 'YYYY/MM/DD HH:mm')
  }

  formatPrice(price: number): string {
    return price.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
  }

  get editedOrderMessage(): string | null {
    return getEditedOrderMessage(this.order)
  }

  get addToCartButtonEligibilityChecker(): AddToCartButtonEligibilityChecker {
    return this.addToCartButtonDependency.eligibilityCheckerBuilder.buildForOrder({ order: this.order })
  }

  get shouldShowPaymentProblem(): boolean {
    return shouldShowPaymentProblemState(this.order)
  }

  get paymentProblemStateView() {
    return getPaymentProblemStateView(this.order, this.statusView)
  }
}
